<template>
  <div>
    <v-snackbar
      v-model="show"
      :color="colour"
      :multi-line="true"
      :timeout="timeout">
        <template v-if="!largeMessage">
          {{ api.message || "Error occured but no message was provided" }}
        </template>
        <template v-else>
          <span v-if="api.code >= 500">A server side error occured, click the view response button to see details</span>
          <span v-else>There was an api error, click the view response button to see details</span>
        </template>
      <v-btn
        dark
        v-if="largeMessage"
        @click="showFullMessage = true">
        View Response
      </v-btn>
      <v-btn
        dark
        flat
        @click="show = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="showFullMessage" width="600px">
      <v-card>
        <v-card-title class="headline red lighten-1">
          Error Response
        </v-card-title>
        <v-card-text>
          <pre>
            {{api.message}}
          </pre>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="showFullMessage = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
export default {
  data () {
    return {
      show: false,
      showFullMessage: false
    }
  },
  computed: {
    ...mapState('notification', ['api']),
    ...mapGetters('notification', ['largeMessage']),
    colour () {
      if (this.api.code === 500) {
        return 'red'
      } else if (this.api.code >= 400 && this.api.code < 500) {
        return 'blue'
      }
      return undefined
    },
    timeout () {
      if (this.api.code >= 400) {
        return 0
      } else {
        return 5000
      }
    }
  },
  watch: {
    'api.message': {
      handler () {
        this.show = true
      }
    }
  }
}
</script>

<style>

</style>
